import { Component, OnDestroy, OnInit } from '@angular/core';
import { LifeCycles, registerApplication, unregisterApplication } from 'single-spa';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import {
  PlatformCommunicatorAuthService,
} from 'src/app/shared/services/communicator/platform-communicator/platform-communicator.auth.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { CryptoVaultService } from 'src/app/shared/services/external/crypto-vault/crypto-vault.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { PlatformEndpointService } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-micro-firmly-approved',
  templateUrl: './micro-firmly-approved.component.html',
  styleUrls: ['./micro-firmly-approved.component.scss'],
})
export class MicroFirmlyApprovedComponent implements OnInit, OnDestroy {

  authSso: any;
  controlFlow: any;
  functions: any;

  constructor(
    private headerService: HeaderService,
    private authService: PlatformCommunicatorAuthService,
    private navigationService: NavigationService,
    private loaderService: LoaderService,
    private abreCuentasService: AbreCuentasService,
    private endpointService: PlatformEndpointService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private firmlyApprovedService: FirmlyApprovedService,
    private parametersService: ParametersService,
    private bioCatchService: BioCatchService,
    private bitacoraService: BitacoraService,
    private identificationService: IdentificationService,
    private validationHelperService: ValidationHelperService,
    private postValidate: PostValidateService,
    private cipherService: CryptoVaultService,
  ) {
    this.headerService.show(false, false, true);
    this.authSso = {
      session_id: this.authService.getSessionId(),
      token: this.authService.getSSOInformation().accessToken,
      transaction_id: this.abreCuentasService.getTransactionId(),
    };
    // this.setProductOffer();
    this.controlFlow = {
      nextStep: (code: any) => {
        this.loaderService.forceHide();
        this.navigationService.nextStep(code);
      },
      previousStep: () => this.navigationService.previousStep(),
      goToHomePage: () => this.navigationService.goToLoginPage(),
    };

    this.functions = {
      getIsLogin: () => this.abreCuentasService.getPostlogin(),
      downloadPdf: (value: any) => this.channelCommunicatorService.getImpl().openPdf(value),
      backpage: () => this.channelCommunicatorService.getImpl().redirectToLoginView(),
      setProductVincu: (value: string) => this.abreCuentasService.setProductsVincu(value),
    };
  }

  ngOnDestroy(): void {
    unregisterApplication('firmlyApproved');
  }

  async ngOnInit() {
    this.loaderService.show('null');
    await this.postValidate.solicitationId();
    registerApplication({
      name: 'firmlyApproved',
      app: (): Promise<LifeCycles> => System.import(this.endpointService.MICROFRONTENDS.FIRMLY_APROVED),
      activeWhen: '/',
      customProps: {
        ssoProps: this.authSso,
        controls: this.controlFlow,
        loader: this.loaderService,
        functions: this.functions,
        abreCuentasService: this.abreCuentasService,
        firmlyApprovedService: this.firmlyApprovedService,
        channelCommunicatorService: this.channelCommunicatorService,
        bioCatchService: this.bioCatchService,
        bitacoraService: this.bitacoraService,
        parametersService: this.parametersService,
        products_firmlyApproved: this.parametersService.getSetting(OpEnum.APROBADOS_FIRME_CE),
        identificationService: this.identificationService,
        validationHelperService: this.validationHelperService,
        navigationService: this.navigationService,
        cipherService: this.cipherService,
      },
    });
  }

}
